import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { SmartintegService } from '../../../services/smartinteg.service';
import { ProvedorConexao, ProvedorEndpoint } from '../../../types/smartinteg';
import { variaveisNaoUsadas } from '../iteracao-config/iteracao.util';

/**
 * Formulário de um Comando de API (conexão, endpoint, corpo, parâmetros e chaves). Edita o modelo no lugar.
 * Comandos de API só guardam o endpoint: a conexão é deduzida dele ao reabrir.
 */
@Component({
  selector: 'app-comando-api-form',
  templateUrl: './comando-api-form.component.html'
})
export class ComandoApiFormComponent implements OnChanges {

  @Input() model!: any;
  @Input() conexoes: ProvedorConexao[] = [];
  @Input() endpointsGlobais: ProvedorEndpoint[] = [];
  @Input() prefixo = 'cmdApi';
  @Input() mostrarCamposChave = false;
  // {{variável}} que o path do endpoint deve usar (avisa quando o path não usa)
  @Input() variaveisEsperadas: string[] = [];

  endpoints: ProvedorEndpoint[] = [];
  private conexaoCarregada: string | null = null;

  constructor(private smartintegService: SmartintegService) { }

  ngOnChanges(changes: SimpleChanges): void {
    if (!this.model) return;
    if (!this.model.conexaoId && this.model.endpointId) {
      this.model.conexaoId = this.endpointsGlobais.find(e => e.id === this.model.endpointId)?.conexaoId;
    }
    this.carregarEndpoints();
  }

  onConexaoChange(): void {
    this.model.endpointId = undefined;
    this.carregarEndpoints();
  }

  private carregarEndpoints(): void {
    const id: string | null = this.model?.conexaoId ?? null;
    if (!id) { this.endpoints = []; this.conexaoCarregada = null; return; }
    if (id === this.conexaoCarregada) return;
    this.conexaoCarregada = id;
    this.smartintegService.listarEndpointsPorConexao(id).subscribe({
      // endpoints legados sem identificador não podem ser vinculados a um comando
      next: data => { if (this.conexaoCarregada === id) this.endpoints = data.filter(e => !!e.id); },
      error: () => { this.endpoints = []; }
    });
  }

  get endpoint(): ProvedorEndpoint | undefined {
    return this.endpoints.find(e => e.id === this.model?.endpointId);
  }

  // Texto com chaves duplas montado aqui: o template não pode conter essa sequência literal
  get textoVariaveisFaltando(): string {
    return this.variaveisFaltando.map(v => '{' + '{' + v + '}' + '}').join(', ');
  }

  get variaveisFaltando(): string[] {
    return this.endpoint ? variaveisNaoUsadas(this.endpoint.path, this.variaveisEsperadas) : [];
  }
}
